module.exports = __webpack_public_path__ + "img/R06v.5d186085.png";